import { del, EndPoints, get, patch, post } from '../';
export function list() {
    return get(EndPoints.homeWounds, { all: 1 });
}
export function createWound(request) {
    return post(EndPoints.homeWoundsCreate, request);
}
export function updateWound(request) {
    return patch(EndPoints.homeWoundsUpdate, request);
}
export function deleteWound(request) {
    return del("" + EndPoints.homeWoundsDelete, request);
}
